






import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import EmployeeContributionHistorySummary from "@/employer/components/profile/EmployeeContributionHistorySummary.vue";
import EmployeeContributionHistory from "@/employer/components/profile/EmployeeContributionHistory.vue";

@Component({
  components: {
    EmployeeContributionHistorySummary,
    EmployeeContributionHistory
  }
})
export default class EmployeePlanYearContributions extends Vue {
  @Prop()
  employeeId: number;
}
